// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"f0345bfe","435":"64e58fa3","453":"2bd6d34c","834":"0b3b9170"}[chunkId] + ".chunk.js";
};